module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part2-6c8e62f4.png";